/**
 * Returns true only for finite positive numbers.
 * Rejects 0, negatives, Infinity, NaN, and non-number types.
 * Used to guard environment variable overrides for timer/timeout values.
 */
export const isValidPositiveNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value) && value > 0;

/**
 * Returns the value unchanged if it is a finite number, otherwise undefined.
 * Use for normalizing API response values or payload fields that should be
 * numeric but may arrive as non-finite or wrong type.
 */
export const toFiniteNumber = (value: unknown): number | undefined =>
  typeof value === "number" && Number.isFinite(value) ? value : undefined;
